
import {defineComponent} from "vue";
import ButtonSide from "./ButtonSide.vue";

export default defineComponent({
  name: "BoxMenu",
  components: { ButtonSide },
  emits: ["toggle-menu"],
  props: {
    isCollapsed: {
      type: Boolean,
      required: true
    }
  }
});
